/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest200Response,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetAddressSuggest422Response,
  GetCommonState400Response,
  GetServerOptions200Response,
  GetSidebarState200Response,
  GetSidebarState500Response,
} from '../models/index'
import {
  GetAddressSuggest200ResponseFromJSON,
  GetAddressSuggest200ResponseToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetAddressSuggest422ResponseFromJSON,
  GetAddressSuggest422ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetServerOptions200ResponseFromJSON,
  GetServerOptions200ResponseToJSON,
  GetSidebarState200ResponseFromJSON,
  GetSidebarState200ResponseToJSON,
  GetSidebarState500ResponseFromJSON,
  GetSidebarState500ResponseToJSON,
} from '../models/index'

export interface GetAddressSuggestRequest {
  address: string
}

/**
 * GeneralApi - interface
 *
 * @export
 * @interface GeneralApiInterface
 */
export interface GeneralApiInterface {
  /**
   * Подсказки адресов по введённой подстроке (DaData). Возвращает только адреса, содержащие почтовый индекс, в виде строк «индекс, адрес». Требуется подтверждённый email.
   * @summary Подсказки по адресу
   * @param {string} address Часть адреса для подсказки
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GeneralApiInterface
   */
  getAddressSuggestRaw(
    requestParameters: GetAddressSuggestRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetAddressSuggest200Response>>

  /**
   * Подсказки адресов по введённой подстроке (DaData). Возвращает только адреса, содержащие почтовый индекс, в виде строк «индекс, адрес». Требуется подтверждённый email.
   * Подсказки по адресу
   */
  getAddressSuggest(
    requestParameters: GetAddressSuggestRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetAddressSuggest200Response>

  /**
   * Отдаёт группу настроек server_options для синхронизации общих констант фронта и сервера. Ключи приводятся к UPPER_CASE (каст camelCase отключён), значения уже приведены репозиторием к PHP-типам (integer/string/float/boolean/array по типу в БД). Любой новый ключ группы попадает в ответ автоматически; для пустой группы values — пустой объект. Требуется подтверждённый email.
   * @summary Получить параметры сервера
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GeneralApiInterface
   */
  getServerOptionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServerOptions200Response>>

  /**
   * Отдаёт группу настроек server_options для синхронизации общих констант фронта и сервера. Ключи приводятся к UPPER_CASE (каст camelCase отключён), значения уже приведены репозиторием к PHP-типам (integer/string/float/boolean/array по типу в БД). Любой новый ключ группы попадает в ответ автоматически; для пустой группы values — пустой объект. Требуется подтверждённый email.
   * Получить параметры сервера
   */
  getServerOptions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServerOptions200Response>

  /**
   * Счётчики для пунктов бокового меню личного кабинета: заявления (с разбивкой по типам), пользовательские регистры (с разбивкой по типам) и мониторинг. Поле applicationsCount — временное поле совместимости, будет удалено после перехода фронта на блок applications. Пользователь с ролью SEE_ALL_APPLICATIONS получает счётчики по всем пользователям, а не только по своим. Требуется подтверждённый email.
   * @summary Получить состояние счётчиков в боковом меню
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GeneralApiInterface
   */
  getSidebarStateRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetSidebarState200Response>>

  /**
   * Счётчики для пунктов бокового меню личного кабинета: заявления (с разбивкой по типам), пользовательские регистры (с разбивкой по типам) и мониторинг. Поле applicationsCount — временное поле совместимости, будет удалено после перехода фронта на блок applications. Пользователь с ролью SEE_ALL_APPLICATIONS получает счётчики по всем пользователям, а не только по своим. Требуется подтверждённый email.
   * Получить состояние счётчиков в боковом меню
   */
  getSidebarState(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetSidebarState200Response>
}

/**
 *
 */
export class GeneralApi extends runtime.BaseAPI implements GeneralApiInterface {
  /**
   * Подсказки адресов по введённой подстроке (DaData). Возвращает только адреса, содержащие почтовый индекс, в виде строк «индекс, адрес». Требуется подтверждённый email.
   * Подсказки по адресу
   */
  async getAddressSuggestRaw(
    requestParameters: GetAddressSuggestRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetAddressSuggest200Response>> {
    if (requestParameters['address'] == null) {
      throw new runtime.RequiredError(
        'address',
        'Required parameter "address" was null or undefined when calling getAddressSuggest().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['address'] != null) {
      queryParameters['address'] = requestParameters['address']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/address-suggest`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetAddressSuggest200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Подсказки адресов по введённой подстроке (DaData). Возвращает только адреса, содержащие почтовый индекс, в виде строк «индекс, адрес». Требуется подтверждённый email.
   * Подсказки по адресу
   */
  async getAddressSuggest(
    requestParameters: GetAddressSuggestRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetAddressSuggest200Response> {
    const response = await this.getAddressSuggestRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Отдаёт группу настроек server_options для синхронизации общих констант фронта и сервера. Ключи приводятся к UPPER_CASE (каст camelCase отключён), значения уже приведены репозиторием к PHP-типам (integer/string/float/boolean/array по типу в БД). Любой новый ключ группы попадает в ответ автоматически; для пустой группы values — пустой объект. Требуется подтверждённый email.
   * Получить параметры сервера
   */
  async getServerOptionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetServerOptions200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/server-options`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetServerOptions200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Отдаёт группу настроек server_options для синхронизации общих констант фронта и сервера. Ключи приводятся к UPPER_CASE (каст camelCase отключён), значения уже приведены репозиторием к PHP-типам (integer/string/float/boolean/array по типу в БД). Любой новый ключ группы попадает в ответ автоматически; для пустой группы values — пустой объект. Требуется подтверждённый email.
   * Получить параметры сервера
   */
  async getServerOptions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetServerOptions200Response> {
    const response = await this.getServerOptionsRaw(initOverrides)
    return await response.value()
  }

  /**
   * Счётчики для пунктов бокового меню личного кабинета: заявления (с разбивкой по типам), пользовательские регистры (с разбивкой по типам) и мониторинг. Поле applicationsCount — временное поле совместимости, будет удалено после перехода фронта на блок applications. Пользователь с ролью SEE_ALL_APPLICATIONS получает счётчики по всем пользователям, а не только по своим. Требуется подтверждённый email.
   * Получить состояние счётчиков в боковом меню
   */
  async getSidebarStateRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetSidebarState200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/sidebar-state`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetSidebarState200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Счётчики для пунктов бокового меню личного кабинета: заявления (с разбивкой по типам), пользовательские регистры (с разбивкой по типам) и мониторинг. Поле applicationsCount — временное поле совместимости, будет удалено после перехода фронта на блок applications. Пользователь с ролью SEE_ALL_APPLICATIONS получает счётчики по всем пользователям, а не только по своим. Требуется подтверждённый email.
   * Получить состояние счётчиков в боковом меню
   */
  async getSidebarState(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetSidebarState200Response> {
    const response = await this.getSidebarStateRaw(initOverrides)
    return await response.value()
  }
}
